class RecipeBoxToggle extends HTMLElement {
	constructor() {
		super();

        this.recipeBoxItems = JSON.parse( localStorage.getItem("recipeBoxItems") ) || { items: [] };
        this.handle         = this.getAttribute('data-handle');
        this.button         = this.querySelector('button');

        this.button.addEventListener('click', this.onButtonClick.bind(this))
	}

    connectedCallback() {
        this.handleButtonContent()
	}

    onButtonClick(e){
        e.preventDefault();

        this.recipeBoxItems = JSON.parse( localStorage.getItem("recipeBoxItems") ) || { items: [] };
        
        let n = !0
        this.recipeBoxItems.items.forEach((t, i) => {
            if( this.handle == t ){
                this.recipeBoxItems.items.splice(i, 1);
                n = !1
            }
        });
        if( n ){
            this.recipeBoxItems.items.push( this.handle );
        }
        
        localStorage.setItem("recipeBoxItems", JSON.stringify(this.recipeBoxItems))

        this.handleButtonContent();
    }

	handleButtonContent() {

		const AddTobox      = this.querySelector("template.add-to-box").innerHTML;
        const RemoveFromBox = this.querySelector("template.remove-from-box").innerHTML;

        if( this.recipeBoxItems.items.includes( this.handle ) ){
            this.button.innerHTML = RemoveFromBox;
        }else{
            this.button.innerHTML = AddTobox;
        }
	}
}
customElements.define("recipe-box-toggle", RecipeBoxToggle);